import { useEntityStore } from '@/data/useEntityStore'
import { wsTopic } from '@/data/websocketTopics'
import { serializeField } from '@/modules/Project/serializer'
import { useWebSocketTopic } from '@/sharedComposables/useWebSocketTopic'
import { computed, type MaybeRefOrGetter } from 'vue'

export function watchProject(props: { projectId: MaybeRefOrGetter<string | undefined | null> }) {
  const entityStore = useEntityStore()

  const projectTopic = computed(() => wsTopic.project(props.projectId))

  const { subscribe } = useWebSocketTopic(projectTopic)

  subscribe('entity:updated', (data) => {
    entityStore.pushEntityJSON(data)
  })

  subscribe('entity:created', (entity) => {
    entityStore.pushEntityJSON(entity)
  })

  subscribe('entity:deleted', (payload) => {
    entityStore.removeEntities([payload.entity_id])
  })

  subscribe('entity:bulk_deleted', (payload) => {
    entityStore.removeEntities(payload.entity_ids)
  })

  subscribe('field:updated', (payload) => {
    const field = serializeField(payload)
    const entity = entityStore.getFullEntity(field.entityId)
    if (!entity) return

    entity.fields.set(field.propertyId, field)
  })
}
